var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconAlert = function SvgIconAlert(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 100 100",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-2 {\n        fill: url(#linear-gradient-4);\n      }\n\n      .cls-3 {\n        fill: url(#linear-gradient-3);\n      }\n\n      .cls-4 {\n        fill: url(#linear-gradient-5);\n      }\n\n      .cls-5 {\n        fill: url(#linear-gradient-8);\n      }\n\n      .cls-6 {\n        fill: url(#linear-gradient-7);\n      }\n\n      .cls-7 {\n        fill: url(#linear-gradient-6);\n      }\n\n      .cls-8 {\n        fill: url(#linear-gradient);\n      }"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 25.25,
    y1: 106.1,
    x2: 98.12,
    y2: 26.77,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#a80096"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#a80096"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 10.73,
    y1: 92.76,
    x2: 83.59,
    y2: 13.43,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -13.67,
    y1: 70.35,
    x2: 59.19,
    y2: -8.98,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 35.13,
    y1: 115.17,
    x2: 107.99,
    y2: 35.84,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: -11.68,
    y1: 72.17,
    x2: 61.18,
    y2: -7.16,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: -22.3,
    y1: 62.42,
    x2: 50.56,
    y2: -16.91,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 12.13,
    y1: 94.05,
    x2: 84.99,
    y2: 14.72,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 18.78,
    y1: 100.16,
    x2: 91.65,
    y2: 20.83,
    xlinkHref: "#linear-gradient"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M91.89,96.15h-10.05v-10.05c0-1.06-.86-1.92-1.92-1.92h-4.06v-34.18c0-14.26-11.6-25.86-25.86-25.86s-25.86,11.6-25.86,25.86v34.18h-4.06c-1.06,0-1.92.86-1.92,1.92v10.05h-10.05c-1.06,0-1.92.86-1.92,1.92s.86,1.92,1.92,1.92h83.79c1.06,0,1.92-.86,1.92-1.92s-.86-1.92-1.92-1.92ZM27.98,50c0-12.14,9.88-22.02,22.02-22.02s22.02,9.88,22.02,22.02v34.18H27.98v-34.18ZM22,88.03h56v8.12H22v-8.12Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M50,57.91c1.06,0,1.92-.86,1.92-1.92v-11.97c0-1.06-.86-1.92-1.92-1.92s-1.92.86-1.92,1.92v11.97c0,1.06.86,1.92,1.92,1.92Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M10.03,50c0-1.06-.86-1.92-1.92-1.92H1.92c-1.06,0-1.92.86-1.92,1.92s.86,1.92,1.92,1.92h6.18c1.06,0,1.92-.86,1.92-1.92Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M98.08,48.08h-6.18c-1.06,0-1.92.86-1.92,1.92s.86,1.92,1.92,1.92h6.18c1.06,0,1.92-.86,1.92-1.92s-.86-1.92-1.92-1.92Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M50,10.03c1.06,0,1.92-.86,1.92-1.92V1.92c0-1.06-.86-1.92-1.92-1.92s-1.92.86-1.92,1.92v6.18c0,1.06.86,1.92,1.92,1.92Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M19.02,21.74c.38.38.87.56,1.36.56s.98-.19,1.36-.56c.75-.75.75-1.97,0-2.72l-4.23-4.23c-.75-.75-1.97-.75-2.72,0-.75.75-.75,1.97,0,2.72l4.23,4.23Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M79.62,22.3c.49,0,.98-.19,1.36-.56l4.23-4.23c.75-.75.75-1.97,0-2.72-.75-.75-1.97-.75-2.72,0l-4.23,4.23c-.75.75-.75,1.97,0,2.72.38.38.87.56,1.36.56Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M50,64.24c-1.07,0-1.93.87-1.93,1.93s.87,1.93,1.93,1.93,1.93-.87,1.93-1.93-.87-1.93-1.93-1.93Z"
  })));
};
export default SvgIconAlert;